import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { OrderProvider } from './src/context/OrderContext';
import { Layout } from './src/components/Layout';
import { Landing } from './src/pages/Landing';
import { PickupDay } from './src/pages/PickupDay';
import { Menu } from './src/pages/Menu';
import { Cart } from './src/pages/Cart';
import { Confirmation } from './src/pages/Confirmation';
// Wrapper for AnimatePresence to work with React Router
const AnimatedRoutes = () => {
  const location = useLocation();
  return <AnimatePresence mode="wait" data-id="element-0">
      <Routes location={location} key={location.pathname} data-id="element-1">
        <Route path="/" element={<Landing data-id="element-3" />} data-id="element-2" />
        <Route path="/pickup" element={<PickupDay data-id="element-5" />} data-id="element-4" />
        <Route path="/menu" element={<Menu data-id="element-7" />} data-id="element-6" />
        <Route path="/cart" element={<Cart data-id="element-9" />} data-id="element-8" />
        <Route path="/confirmation" element={<Confirmation data-id="element-11" />} data-id="element-10" />
      </Routes>
    </AnimatePresence>;
};
import { LanguageProvider } from './src/context/LanguageContext';
export function App() {
  return <BrowserRouter data-id="element-12">
      <LanguageProvider data-id="element-13">
        <OrderProvider data-id="element-14">
          <Layout data-id="element-15">
            <AnimatedRoutes data-id="element-16" />
          </Layout>
        </OrderProvider>
      </LanguageProvider>
    </BrowserRouter>;
}